export const momentLocale = lng => {
    return lng === 'ua' ? 'uk' : lng;
};
